import type { ReactNode } from 'react'
import AirRoundedIcon from '@mui/icons-material/AirRounded'
import FloodRoundedIcon from '@mui/icons-material/FloodRounded'
import LocalFireDepartmentRoundedIcon from '@mui/icons-material/LocalFireDepartmentRounded'
import WaterDropRoundedIcon from '@mui/icons-material/WaterDropRounded'
import WbSunnyRoundedIcon from '@mui/icons-material/WbSunnyRounded'
import AutoGraphRoundedIcon from '@mui/icons-material/AutoGraphRounded'
import { CanonicalPeriod, PERIODS } from './index'

export type HazardViewConfig = {
  availablePeriods: CanonicalPeriod[]
  defaultPeriod: CanonicalPeriod
}

export type HazardVisualMeta = {
  icon: ReactNode
  tone: string
  accent: string
}

const multiPeriodHazardConfig: HazardViewConfig = {
  availablePeriods: PERIODS,
  defaultPeriod: CanonicalPeriod.LONG_TERM,
}

const climateHazardViewConfigByCode: Record<string, HazardViewConfig> = {
  fld: multiPeriodHazardConfig,
  hs: multiPeriodHazardConfig,
  tc: {
    availablePeriods: [CanonicalPeriod.LONG_TERM],
    defaultPeriod: CanonicalPeriod.LONG_TERM,
  },
  wf: multiPeriodHazardConfig,
  wr: multiPeriodHazardConfig,
}

const fallbackHazardViewConfig: HazardViewConfig = multiPeriodHazardConfig

const climateHazardVisualMetaByCode: Record<string, HazardVisualMeta> = {
  fld: {
    icon: <FloodRoundedIcon fontSize="small" />,
    tone: '#0f3d5e',
    accent: '#9fd0f4',
  },
  hs: {
    icon: <WbSunnyRoundedIcon fontSize="small" />,
    tone: '#a15c00',
    accent: '#ffd37a',
  },
  tc: {
    icon: <AirRoundedIcon fontSize="small" />,
    tone: '#115e59',
    accent: '#97f0e3',
  },
  wf: {
    icon: <LocalFireDepartmentRoundedIcon fontSize="small" />,
    tone: '#7f1d1d',
    accent: '#f7b0a9',
  },
  wr: {
    icon: <WaterDropRoundedIcon fontSize="small" />,
    tone: '#0f4c81',
    accent: '#a8dcff',
  },
}

const fallbackHazardVisualMeta: HazardVisualMeta = {
  icon: <AutoGraphRoundedIcon fontSize="small" />,
  tone: '#334155',
  accent: '#cbd5e1',
}

export function getClimateHazardViewConfig(hazardCode?: string | null): HazardViewConfig {
  if (!hazardCode) return fallbackHazardViewConfig
  return climateHazardViewConfigByCode[hazardCode] ?? fallbackHazardViewConfig
}

export function getClimateHazardVisualMeta(hazardCode?: string | null): HazardVisualMeta {
  if (!hazardCode) return fallbackHazardVisualMeta
  return climateHazardVisualMetaByCode[hazardCode] ?? fallbackHazardVisualMeta
}
